import CssBaseline from "@mui/material/CssBaseline";
import App from "app";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "store";
import { ThemeManager } from "utils";
import "././api/interceptors";
import "./assets/styles/styles.scss";
ThemeManager.initTheme();
const theme = ThemeManager.getTheme();
ThemeManager.setTheme(theme);
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CssBaseline />
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
